export default __webpack_public_path__ + "static/media/header-background.cef24f8d.svg";